import { DESKTOP_LANDING_PATH, MOBILE_LANDING_PATH } from '@/components/LayoutDetector/hooks';
import { getPostAuthDestination } from '@/shared/postAuthDestination';

function getEmailVerificationPath({ isGiftCardUser, plan, price, isMobileLayout = false }) {
  let path;
  if (isGiftCardUser) {
    path = '/redeem';
  } else if (plan && price) {
    path = DESKTOP_LANDING_PATH;
  } else {
    const newPath = getPostAuthDestination();
    path = newPath ?? (isMobileLayout ? MOBILE_LANDING_PATH : DESKTOP_LANDING_PATH);
  }
  return path;
}

export default getEmailVerificationPath;
